import { Component } from '@angular/core';
import { AbstractFormControl } from '../abstract-form-control';
import {
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { SensorDetailDto } from '@artemis-software/wr-api';
import SensorIntegrationTypeEnum = SensorDetailDto.SensorIntegrationTypeEnum;

@Component({
  standalone: false,
  selector: 'wr-sensor-integration-type-select',
  templateUrl: './sensor-integration-type-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SensorIntegrationTypeSelectComponent,
      multi: true,
    },
  ],
})
export class SensorIntegrationTypeSelectComponent extends AbstractFormControl<SensorIntegrationTypeEnum> {
  readonly values = Object.values(SensorIntegrationTypeEnum);

  placeholder = 'Integrationstyp auswählen';
}
